import React from "react";
import { useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import HelmetWrapper from "../../HelmetWrapper";
import { selectUser } from "../../components/auth/auth.selector";
import AgentReportDateWise from "../../components/lead-management/agent-report/agentReportDateWise";

const TaskSOP = () => {
  const userInfoData = useSelector(selectUser);

  return (
    <HelmetWrapper title="WTF: FD/Trainer Sales">
      <Container className="bg-cloud-k px-50px gobal-container" fluid>
        <Row>
          <Col>
            <AgentReportDateWise
              userInfoData={userInfoData}
              pageName="task-sop"
            />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default TaskSOP;
